import {
  Box,
  Typography,
  Button,
  DialogContent,
  DialogActions,
  Dialog,
} from '@mui/material';
import { WarningAmberOutlined } from '@mui/icons-material';
import { trackAnalyticsEvent } from '../../../../utils/clevertap';
import { useSelector } from 'react-redux';

export default function AgeWarningModal({ updateRelation, showAgeModal, close, callBloodRelationAPI, owner_type_text }) {
  const userData = useSelector(state => state.user?.userData);

  const handleEditPanClick = () => {
    trackAnalyticsEvent('BENEFICIARY_AGE_WARNING_EDIT_PAN_CLICK', {
      manufacturer_id: userData?.manufacturer_id || '',
      action: 'edit_pan'
    });
    close();
  };

  const handleSelectBloodRelativesClick = () => {
    trackAnalyticsEvent('BENEFICIARY_AGE_WARNING_BLOOD_RELATIVES_CLICK', {
      manufacturer_id: userData?.manufacturer_id || '',
      action: 'select_blood_relatives',
      owner_type: owner_type_text?.value || ''
    });
    callBloodRelationAPI(owner_type_text.value);
  };

  return (
    <Dialog 
        open={showAgeModal} 
        onClose={close} 
        PaperProps={{
            sx: { borderRadius: 3, 
            width:"350px" }
        }}
    >
        <DialogContent sx={{ p: 2 }} >
            <Box sx={{ textAlign: 'center'}}>
                <WarningAmberOutlined sx={{ fontSize: 50, color: '#CC0000', mb: 2 }} />
                <Typography variant="h6" sx={{ color: '#CC0000', fontWeight: 'bold', mb: 2 }}>
                    Age &gt; 60 years
                </Typography>
                <Typography sx={{ color: '#333333', }}>
                    Please select from below
                </Typography>
            </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, display: 'flex', justifyContent: !updateRelation ? 'space-between': 'center' }}>
            <Button onClick={handleEditPanClick} color="primary" sx={{ textTransform: 'none' }} variant='outlined'>
                Edit PAN
            </Button>
            {!updateRelation && (
                <Button
                    variant='contained'
                    onClick={handleSelectBloodRelativesClick}
                    color="primary"
                    sx={{ textTransform: 'none' }}
                >
                    Select Blood Relatives
                </Button>
            )}
        </DialogActions>
    </Dialog>
  );
}
